import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    ON_PASSWORD_POLICY_LIST,
    ON_PASSWORD_POLICY_ADD,
    ON_PASSWORD_POLICY_UPDATE
  } from "../constants/ActionTypes";
  import {adminAPI} from 'util/Api';

  export const getPasswordPolicyList = () => {
    //console.log('Am here');
     const _data = {
       data: {}
     };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('passwordpolicies',_data //name of the API
         ).then(({data}) => { 
         // alert(JSON.stringify(data))
           //console.log('Success');
         //console.log("Fetched Users: ", data);
         if (data.length) {
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_PASSWORD_POLICY_LIST, payload: data});
         } else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }